import landing from './landing';
import contentful from './contentful';
import custom from './custom';
import user from './user';
import wizard from './wizard';

const index = {
  landing,
  contentful,
  custom,
  user,
  wizard,
};

export default index;